import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FileLocalMultiUploadRedesigned = _resolveComponent("FileLocalMultiUploadRedesigned")!
  const _component_CalculationForm = _resolveComponent("CalculationForm")!
  const _component_CalculationPageWrapper = _resolveComponent("CalculationPageWrapper")!

  return (_ctx.isAccessAllowed)
    ? (_openBlock(), _createBlock(_component_CalculationPageWrapper, {
        key: 0,
        title: "Выгрузка еженедельных данных",
        type: _ctx.getType,
        isUploadingFile: _ctx.isUploadingFile
      }, {
        default: _withCtx(() => [
          _createVNode(_component_CalculationForm, {
            buttonText: "Загрузить данные",
            disabled: _ctx.getIsLoading,
            isLoading: _ctx.getIsFormLoading,
            onSubmit: _ctx.handleSubmitForm
          }, {
            fields: _withCtx(() => [
              _createVNode(_component_FileLocalMultiUploadRedesigned, {
                modelValue: _ctx.files,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.files) = $event)),
                showEmpty: "",
                title: "Загрузка еженедельных данных",
                subtitle: _ctx.getFileSubtitle,
                validExtensions: [_ctx.FILE_PATH],
                disabled: _ctx.getIsFormLoading,
                required: ""
              }, null, 8, ["modelValue", "subtitle", "validExtensions", "disabled"])
            ]),
            _: 1
          }, 8, ["disabled", "isLoading", "onSubmit"])
        ]),
        _: 1
      }, 8, ["type", "isUploadingFile"]))
    : _createCommentVNode("", true)
}